module.exports = __webpack_public_path__ + "img/kulturna-iskaznica-logo.904b8557.jpg";